import axios from 'axios'
import { cardUrl, getHeader } from '@/config'

const state = {
  cardList: []
}

const mutations = {
  SET_CARD_LIST (state, obj) {
    state.cardList = obj
  }
}

const actions = {
  getCardList: ({ commit }) => {
    axios.get(cardUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_CARD_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
